import { useMutation } from "@tanstack/react-query";

import { api } from "@/lib/api-client";

import type { MutationConfig } from "@/lib/react-query";

export type ReasonOption = "not_satisfied" | "missing_features" | "not_using" | "other";

export interface DeleteAccountParams {
  competitor?: string;
  reason?: ReasonOption;
}

export const deleteProfileFn = async (params?: DeleteAccountParams) => {
  return api.put("/carburate/users/delete/", {
    data: params,
  });
};

type UseDeleteProfileOptions = {
  mutationConfig?: MutationConfig<typeof deleteProfileFn>;
};

export const useDeleteProfile = ({ mutationConfig }: UseDeleteProfileOptions = {}) => {
  return useMutation({
    mutationFn: deleteProfileFn,
    ...mutationConfig,
  });
};
